import { Injectable } from '@angular/core';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { randColor, randText, randWord } from '@ngneat/falso';
import { OrderedSet } from 'immutable';

import { SubscriptionProjectItemEntity } from './components/subscription-configuration-stepper/subscription-project-item.entity';

@Injectable()
export class SubscriptionDataMockService {
	public generateProjects(count = 5): Array<SubscriptionProjectItemEntity> {
		return Array.from({
			length: count,
		}).map((_, index) =>
			SubscriptionProjectItemEntity.build({
				id: index + 1,
				label: randText({
					charCount: 20,
				}),
				description: randText({
					charCount: 1500,
				}),
				tags: this.generateMockTags(3),
			})
		);
	}

	private generateMockTags(count = 5): OrderedSet<AppTagItemEntity> {
		const tags: Array<AppTagItemEntity> = Array.from({
			length: count,
		}).map((_, index) =>
			AppTagItemEntity.build({
				id: index + 1,
				position: index,
				label: randWord(),
				color: randColor(),
				foreground: 'black',
			})
		);

		return OrderedSet(tags);
	}
}
